$(document).ready(function() {
	// #### page : solution slick scripts
	if(!document.querySelector('.my-Products')) return false;

	var isRTL = $('html').attr('dir') == 'rtl' ? true : false;
	
	var $obj = $('.my-Products');
	var slickOption = {
		rtl : isRTL,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows : true,
		dots: true,
		listStyle : true,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows : true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows : false
			}
		}],
		prevArrow: carouselOptions.bigAnglePrev, // common.js variable
		nextArrow: carouselOptions.bigAngleNext // common.js variable
	};
	
	if ( isRTL ){
		slickOption.prevArrow = carouselOptions.bigAngleNext;
		slickOption.nextArrow = carouselOptions.bigAnglePrev;

	} else {

	}
	var $slick = $obj.find('.product-type .items').slick( slickOption );

    $obj.find('.product-type .items .item').each(function(){
        $(this).on('click', function( e ){
            e.preventDefault();
            var modelName = $(this).find('.model-name .text').text();
            $('#search-keyword').val( modelName );
			$('#select_registered_model').modal('hide');
			setTimeout(function(){
                $('#search-keyword').trigger('focus');
            }, 1000);
        });
    });
    
    // Pop up
   $('#select_registered_model').on({
        'shown.bs.modal': function(e){
            //adobeTrackEvent('find_my_model', {page_event : {find_my_model : true}});
            $('#myProductList .items').slick('setPosition');            
        },
        'hidden.bs.modal': function(e){
            
        }
    });

    
});